<nav class="tfx-editor-tabs optionsPanel">
    <div class="gsp-tabs optionsTabs">
        <section>
            <ng-container *ngFor="let tab of tabsList">
                <div
                    title="{{ tab.name | translate }}"
                    tooltipLocation="bottom"
                    (click)="activateTab(tab)"
                    [ngClass]="{ active: tab.id == selectedTab.id }"
                    *ngIf="
                        tab.id !== TemplateEditorTabId.LINK ||
                        linkDetails.length > 1 ||
                        secondaryUniqLinkDetails.length > 1
                    "
                >
                    <i class="{{ tab.iconClass }} i32"></i>
                    <span translate>{{ tab.name }}</span>
                </div>
            </ng-container>
        </section>
    </div>
    <div class="options">
        <section class="height-full">
            <custom-scroll>
                <template-panel
                    [template]="template"
                    [templateEditorConfig]="templateEditorConfig"
                    [hidden]="selectedTab.id !== TemplateEditorTabId.DETAIL"
                ></template-panel>
                <field-panel
                    [application]="application"
                    [templateEditorConfig]="templateEditorConfig"
                    [template]="template"
                    [hidden]="selectedTab.id !== TemplateEditorTabId.FIELDS"
                ></field-panel>
                <style-symbology-panel
                    [template]="template"
                    [templateStyle]="templateStyle"
                    [hidden]="selectedTab.id !== TemplateEditorTabId.STYLE"
                ></style-symbology-panel>
                <rules-panel [template]="template" [hidden]="selectedTab.id !== TemplateEditorTabId.RULE"></rules-panel>
                <ng-container>
                    <links-panel
                        [template]="template"
                        [linkDetails]="linkDetails"
                        [hidden]="
                            selectedTab.id !== TemplateEditorTabId.LINK ||
                            (linkDetails.length <= 1 && secondaryUniqLinkDetails.length <= 1)
                        "
                    ></links-panel>
                </ng-container>
            </custom-scroll>
        </section>
    </div>
</nav>
